import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _BUSINESS_TYPE_LABEL, _EMPLOYMENT_TYPE_LABE;

export var CUSTOMER_TYPE = {
  PERSONAL: 0,
  BUSINESS: 1
};
export var ADDRESS_TYPE = {
  CURRENT: 'CURRENT',
  PREVIOUS: 'PREVIOUS',
  GARAGE: 'GARAGE'
};
export var EMPLOYER_TYPE = {
  CURRENT: 'CURRENT',
  PREVIOUS: 'PREVIOUS'
};
export var BUSINESS_TYPE = {
  INDIVIDUAL: 'INDIVIDUAL',
  CORPORATION: 'CORPORATION',
  LLC: 'LLC',
  PARTNERSHIP: 'PARTNERSHIP',
  PROPRIETOR: 'PROPRIETOR',
  MANDATORY: 'MANDATORY'
};
export var BUSINESS_TYPE_LABEL = (_BUSINESS_TYPE_LABEL = {}, _defineProperty(_BUSINESS_TYPE_LABEL, BUSINESS_TYPE.INDIVIDUAL, 'Individual'), _defineProperty(_BUSINESS_TYPE_LABEL, BUSINESS_TYPE.CORPORATION, 'Corporation'), _defineProperty(_BUSINESS_TYPE_LABEL, BUSINESS_TYPE.LLC, 'LLC'), _defineProperty(_BUSINESS_TYPE_LABEL, BUSINESS_TYPE.PARTNERSHIP, 'Partnership'), _defineProperty(_BUSINESS_TYPE_LABEL, BUSINESS_TYPE.PROPRIETOR, 'Proprietor'), _defineProperty(_BUSINESS_TYPE_LABEL, BUSINESS_TYPE.MANDATORY, 'Mandatory'), _BUSINESS_TYPE_LABEL);
export var RESIDENT_TYPE = {
  OTHER: 'OTHER',
  BUYING_HOME: 'BUYING_HOME',
  LIVING_WITH_RELATIVES: 'LIVING_WITH_RELATIVES',
  LEASING: 'LEASING',
  RENTING: 'RENTING',
  OWNS_MOBILE_HOME: 'OWNS_MOBILE_HOME',
  OWNS: 'OWNS',
  GOVERNMENT_HOUSING: 'GOVERNMENT_HOUSING',
  OWNS_OUTRIGHT: 'OWNS_OUTRIGHT',
  BOARDS: 'BOARDS'
};
export var EMPLOYMENT_TYPE = {
  FULL_TIME: 'FULL_TIME',
  PART_TIME: 'PART_TIME',
  RETIRED_MILITARY: 'RETIRED_MILITARY',
  CONTRACT_SEASONAL: 'CONTRACT_SEASONAL',
  TEMPORARY: 'TEMPORARY',
  SELF_EMPLOYED: 'SELF_EMPLOYED',
  UNEMPLOYED: 'UNEMPLOYED',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
  RETIRED: 'RETIRED'
};
export var EMPLOYMENT_TYPE_LABEL = (_EMPLOYMENT_TYPE_LABE = {}, _defineProperty(_EMPLOYMENT_TYPE_LABE, EMPLOYMENT_TYPE.FULL_TIME, 'Full Time'), _defineProperty(_EMPLOYMENT_TYPE_LABE, EMPLOYMENT_TYPE.PART_TIME, 'Part Time'), _defineProperty(_EMPLOYMENT_TYPE_LABE, EMPLOYMENT_TYPE.RETIRED_MILITARY, 'Retired Military'), _defineProperty(_EMPLOYMENT_TYPE_LABE, EMPLOYMENT_TYPE.CONTRACT_SEASONAL, 'Contract Seasonal'), _defineProperty(_EMPLOYMENT_TYPE_LABE, EMPLOYMENT_TYPE.TEMPORARY, 'Temporary'), _defineProperty(_EMPLOYMENT_TYPE_LABE, EMPLOYMENT_TYPE.SELF_EMPLOYED, 'Self Employed'), _defineProperty(_EMPLOYMENT_TYPE_LABE, EMPLOYMENT_TYPE.UNEMPLOYED, 'Unemployed'), _defineProperty(_EMPLOYMENT_TYPE_LABE, EMPLOYMENT_TYPE.NOT_APPLICABLE, 'Not Applicable'), _defineProperty(_EMPLOYMENT_TYPE_LABE, EMPLOYMENT_TYPE.RETIRED, 'Retired'), _EMPLOYMENT_TYPE_LABE);
export var PRIMARY_DRIVER_TYPE = {
  SAME: 'APPLICANT',
  SAME_AS_CO_BUYER: 'CO_APPLICANT',
  OTHER: 'OTHER'
};
export var MEDIA_TYPE = {
  EMPLOYMENT: 'EMPLOYMENT',
  INSURANCE: 'INSURANCE',
  LICENSE: 'LICENSE'
};
export var FORM_FIELD = {
  CUSTOMER_DETAILS: 'customer',
  CUSTOMER_PREVIEW: 'preview',
  PERSONAL_ADDRESS: 'personalAddress',
  BUSINESS_ADDRESS: 'businessAddress',
  LICENSE_DETAILS: 'licenseDetails',
  LICENSE_UPLOAD: 'licenseUpload',
  INSURANCE_DETAILS: 'insuranceDetails',
  INSURANCE_UPLOAD: 'insuranceUpload',
  EMPLOYMENT_DETAILS: 'employmentDetails',
  EMPLOYMENT_UPLOAD: 'employmentUpload',
  GARAGING_ADDRESS: 'garagingAddress',
  PRIMARY_DRIVER: 'driverDetails',
  EXTERNAL_CUSTOMER_ID: 'externalCustomerId',
  CONTRACTING: 'contracting'
};
export var MAX_LENGTHS = {
  STATE: 2
};
export var EMPLOYER_CATEGORIES = {
  OEM: 'OEM',
  GENERAL: 'GENERAL'
};
export var DURATION_TYPE_STYLE = {
  width: 65,
  border: 0
};
export var DURATION_TYPES = {
  MONTH: 'MONTH',
  YEAR: 'YEAR'
};